import serviceApi from 'services/api';
import auth from 'services/auth';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

export type IctCredentialResponse = {
  id: string;
  facilityNumber?: number;
  cardNumber?: number;
  status?: string;
  issuedTo?: string;
  issuedBy?: string;
};

/* The function `getIctCredential` is an asynchronous function that makes a GET request to the `/apiv1/admin/ict/credential/${uuid}` 
endpoint to fetch the ICT credential linked to the card. */
const getIctCredential = async (uuid?: string): Promise<IctCredentialResponse> => {
  const response = await api.get<IctCredentialResponse>(`/apiv1/admin/ict/credential/${uuid}`);
  return response?.data;
};

const IctService = {
  getIctCredential
};

export default IctService;
